import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { SectionWrapper, ContainerWrapper, HelmetTitle } from "../../Components/Utils";
import Layout from "../../Components/Layout";
import Navbar from "../BannerItems/Components/Navigation";
import { GlobalNetwork } from "../../Components/Networks";
import Banner from "../Certificates/Components/Banner";

import BannerBig from "../../Images/min-1600-hero.jpg";
import BannerSmall from "../../Images/max-600-hero.jpg";

import NCISbig from "../../Images/Experience/min-NCIS-card.jpg";
import PMbig from "../../Images/Experience/min-PMvisit-card.jpg";
import UNILAGbig from "../../Images/Experience/min-UNILAG-card.jpg";
import IHackbig from "../../Images/Experience/min-iHack-card.jpg";
import ESUTbig from "../../Images/Experience/min-ESUT-card.jpg";
import ChallengeCupbig from "../../Images/Experience/min-ChallengeCup-card.jpg";
import APPMbig from "../../Images/Experience/min-APPM-card.jpg";
import TEBIndia from "../../Images/Experience/min-TEB-1.jpg";
import TEBCIAP from "../../Images/Experience/min-CIAP-card.jpg";
import NCISNigeria from "../../Images/Experience/Events/ncis-event-06.jpg";
import UNILAGNigeria from "../../Images/Experience/Events/visit-to-unilag-01.jpg";


const eventsList = [
  {
    name: "APPM",
    subText: "The Presidents and Vice President, APPM-Hong Kong and APPM-Canada visit",
    url: "/experiences/APPM",
    banner: {
      big: APPMbig,
    },
    internal: true,
  },
  {
    name: "Challenge cup",
    subText: "Ottawa mayor’s cyber challenge cup",
    url: "/experiences/ChallengeCup2017",
    banner: {
      big: ChallengeCupbig,
    },
    internal: true,
  },
  {
    name: "ESUT",
    subText: "Senior representatives from the Enugu State University of Science and Technology (ESUT) visit",
    url: "/experiences/Esut",
    banner: {
      big: ESUTbig,
    },
    internal: true,
  },
  {
    name: "iHack",
    subText: "iHack conference to build cybersecurity expertise",
    url: "/experiences/IHack2017",
    banner: {
      big: IHackbig,
    },
    internal: true,
  },
  {
    name: "NCIS",
    subText: "Nigeria-Canada Investment Summit - Abuja",
    url: "/experiences/NCIS",
    banner: {
      big: NCISbig,
    },
    internal: true,
  },
  
  {
    name: "PM at CBY",
    subText: "Prime Minister of Canada, Justin Trudeau's visit to Cours Bayview Yards",
    url: "/experiences/PMvisit2018",
    banner: {
      big: PMbig,
    },
    internal: true,
  },
  
  {
    name: "UNILAG",
    subText: "Senior representatives from the University of Lagos (UNILAG) visit",
    url: "/experiences/Unilag",
    banner: {
      big: UNILAGbig,
    },
    internal: true,
  },
  {
    name: "TVS India ",
    subText: "Increase women entrepreneurs' capability to grow ventures in foreign markets",
    url: "/experiences/venture-scalecamp-india",
    banner: {
      big: TEBIndia,
    },
    internal: true,
  },
   {
    name: "TVS CIAP ",
    subText: "Increase women entrepreneurs' capability to grow ventures in foreign markets",
    url: "/experiences/venture-scalecamp-CIAP",
    banner: {
      big: TEBCIAP,
    },
    internal: true,
  },
  {
    name: "Visit to UNILAG, Nigeria ",
    subText: "GERS representatives visit UNILAG, Lagos, Nigeria",
    url: "/experiences/2018-visit-to-unilag-lagos",
    banner: {
      big: UNILAGNigeria,
    },
    internal: true,
  },
  {
    name: "NCIS Event, Nigeria ",
    subText: "First-ever Nigeria-Canada Investment Summit focused fostering business partnership between both countries",
    url: "/experiences/ncis-2018-abuja-nigeria",
    banner: {
      big: NCISNigeria,
    },
    internal: true,
  },
];

const eventTheme = {
  textAlign: "center",
  height: "348px",
  maxHeight: "352px",
  backColor: "#f9f7f7",
  boxShadow: "8px 10px 20px 0 rgba(47, 63, 77, 0.15)",
  borderRadius: "0.25rem",
  borderTop: "0",
  textHoverColor: "hsl(0, 0%, 16%)",
}
const EventWrapper = styled.ul`
  width: 65%;
  text-align: center;
  padding: 0 2rem;
  margin: 0 auto;
  > li {
    display: block;
    padding: 10px 0;
    border-bottom: 1px solid #f1f1f1;

    > a {
    color: #333;
    text-decoration: none;
    &:hover,
    &:active {
      color: #fff;
      background-color: hsl(217,40%,57%);
      padding: 5px 10px;
    }
  }
  }
  
`;
class EventsDirectory extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render () {
   const name = "Experiences";
    return (
      <div className="App">
      <HelmetTitle title="Experiences" />
      <Layout
        head={<Navbar />}
        body={
          <React.Fragment>
            <Banner certName={name} imgPathMin={BannerBig} imgPathMax={BannerSmall} />
            <EventList />
          </React.Fragment>
	}
      />
    </div>  
    )
  }
}

function EventList() {
  return (
    <SectionWrapper backgroundColor="white" mt="2rem" mb="3rem">
      <ContainerWrapper textAlign="center">
        <GlobalNetwork 
            title="" 
            minCardWidth="220px" 
            maxCardWidth="auto"
            cardGap="20px"
            cards={eventsList}
            theme={eventTheme}
          />
      </ContainerWrapper>
    </SectionWrapper>
  );
}

export default withRouter(EventsDirectory)



// WEBPACK FOOTER //
// ./src/Pages/Experiences/Events.js